module.exports = __webpack_public_path__ + "static/media/pop-banner-store-preview-desktop.80c25fe9.webp";